import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { Announcement } from "./schema";
import { DataTableColumnHeader } from "./data-table-column-header";

import { DataTableRowActions } from "./data-table-row-actions";
import { datesMatch } from "@/utils";

function getTimeSinceNotification(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const elapsedMilliseconds = now.getTime() - date.getTime();
  const elapsedSeconds = Math.floor(elapsedMilliseconds / 1000);
  const elapsedMinutes = Math.floor(elapsedSeconds / 60);
  const elapsedHours = Math.floor(elapsedMinutes / 60);
  const elapsedDays = Math.floor(elapsedHours / 24);

  if (elapsedDays > 0) {
    return `${elapsedDays} day${elapsedDays > 1 ? "s" : ""} ago`;
  } else if (elapsedHours > 0) {
    return `${elapsedHours} hour${elapsedHours > 1 ? "s" : ""} ago`;
  } else if (elapsedMinutes > 0) {
    return `${elapsedMinutes} minute${elapsedMinutes > 1 ? "s" : ""} ago`;
  } else {
    return `${elapsedSeconds} second${elapsedSeconds !== 1 ? "s" : ""} ago`;
  }
}

export const columns: ColumnDef<Announcement, any>[] = [
  {
    accessorKey: "createdAt",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Index" />
    ),
    cell: ({ row }) => (
      <div className="w-[180px] flex flex-col">
        <span>{row.index + 1}</span>
        <span className="text-xs">
          ( {getTimeSinceNotification(row.getValue("createdAt"))} )
        </span>
        <span className="text-xs">
          (Created at - {format(row.getValue("createdAt"), "PPP")} )
        </span>
      </div>
    ),
    enableSorting: false,
    enableHiding: false,

    filterFn: (row, id, value) => {
      return datesMatch(row.getValue(id), value);
    },
  },
  {
    accessorKey: "title",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Title" />
    ),
    cell: ({ row }) => (
      <div className="flex flex-col gap-1">
        <span>{row.getValue("title")}</span>
      </div>
    ),
    enableSorting: false,
  },

  // {
  //   accessorKey: "leaveType",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Leave Type" />
  //   ),
  //   cell: ({ row }) => <div>{row.getValue("leaveType")}</div>,
  //   enableColumnFilter: false,
  //   enableSorting: false,
  // },

  // {
  //   accessorKey: "status",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Status" />
  //   ),
  //   cell: ({ row }) => (
  //     <div>
  //       <Badge variant="outline">{row.getValue("status")}</Badge>
  //     </div>
  //   ),
  //   enableColumnFilter: false,
  //   enableSorting: false,
  // },
  // {
  //   accessorKey: "reason",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Reason" />
  //   ),
  //   cell: ({ row }) => <div>{row.getValue("reason")}</div>,
  //   enableColumnFilter: false,
  //   enableSorting: false,
  // },

  // {
  //   accessorKey: "startDate",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Start Date" />
  //   ),
  //   cell: ({ row }) => <div>{format(row.getValue("startDate"), "PPP")}</div>,
  //   enableColumnFilter: false,
  //   enableSorting: false,
  // },

  // {
  //   accessorKey: "endDate",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="End Date" />
  //   ),
  //   cell: ({ row }) => <div>{format(row.getValue("endDate"), "PPP")}</div>,
  //   enableColumnFilter: false,
  //   enableSorting: false,
  // },

  {
    id: "actions",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
